import { HttpInterceptorFn } from '@angular/common/http';

function trimStrings(value: unknown): unknown {
  if (typeof value === 'string') {
    return value.trim();
  }

  if (Array.isArray(value)) {
    return value.map(trimStrings);
  }

  if (value !== null && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype) {
    const trimmed: Record<string, unknown> = {};
    for (const [key, val] of Object.entries(value)) {
      trimmed[key] = trimStrings(val);
    }
    return trimmed;
  }

  return value;
}

export const trimInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.body && typeof req.body === 'object' && !(req.body instanceof FormData)) {
    const trimmedBody = trimStrings(req.body);
    return next(req.clone({ body: trimmedBody }));
  }

  return next(req);
};
